import PinIcon from '../../../images/PinIcon';

const { InnerBlocks } = wp.blockEditor;

const Save = ({ attributes }) => {
  const { variant, margin } = attributes;

  return (
    <div className={`locate-selector ${variant} ${margin}`}>
      <div>
        <InnerBlocks.Content />
      </div>

      <div className={`Card-col-item locate margin-none`}>
        <PinIcon />

        <div className="Card-col-item-text">
          <p className="city">Cidade</p>
          <p className="address">Endereço</p>
          <a href="" className="tel">
            Telefone
          </a>
          <p className="schedules">Horários</p>
          <a href="" className="gmaps">
            Abrir no Google Maps
          </a>
        </div>
      </div>
    </div>
  );
};

export default Save;
